import { render, staticRenderFns } from "./SocialPostWordCount.vue?vue&type=template&id=0bc6449b&"
import script from "./SocialPostWordCount.vue?vue&type=script&lang=js&"
export * from "./SocialPostWordCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc6449b')) {
      api.createRecord('0bc6449b', component.options)
    } else {
      api.reload('0bc6449b', component.options)
    }
    module.hot.accept("./SocialPostWordCount.vue?vue&type=template&id=0bc6449b&", function () {
      api.rerender('0bc6449b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialPostWordCount.vue"
export default component.exports